import React from 'react';
import PropTypes from 'prop-types';
import { getIn, useFormikContext } from 'formik';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';
import Checkbox from 'core/components/checkbox';
import { Label } from 'core/components/label';
import { tooltipHoverTexts } from 'core/helpers/constants';

// New Mexico: combined UM/UIM at policy level, plus per-vehicle UM/UIM rejection
// per github issue #29925.
const NewMexicoAutoLimits = ({ id, disabled, UMBIOptions }) => {
  const { values, setFieldValue } = useFormikContext();
  const cars = getIn(values, 'cars') || [];

  return (
    <>
      <Grid item xs={6}>
        <LabelTooltip
          label="Un/Underinsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMBI`}
            id={`${id}.policyLimitUMBI`}
            type="select"
            options={UMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>

      {cars.length > 0 && (
        <Grid item xs={12}>
          <Label type="formSubTitle">Reject UM/UIM coverage per vehicle</Label>
          {cars.map((car, index) => {
            const checked = !!getIn(values, `cars.${index}.umuimRejected`);
            const carLabel =
              [car.year, car.make, car.model].filter(Boolean).join(' ') || car.VIN || `Vehicle ${index + 1}`;
            return (
              <Checkbox
                key={car.VIN || `nm-umuim-reject-${index}`}
                type="checkbox"
                id={`cars.${index}.umuimRejected`}
                label={`Reject UM/UIM coverage for ${carLabel}`}
                disabled={disabled}
                value={checked}
                onChange={(e) => {
                  setFieldValue(`cars.${index}.umuimRejected`, e.target.checked);
                }}
              />
            );
          })}
        </Grid>
      )}
    </>
  );
};

NewMexicoAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired
};

NewMexicoAutoLimits.defaultProps = {
  disabled: false
};

export default NewMexicoAutoLimits;
